import { Money } from '../../atoms'
import { DELIVERY_TYPES, DELIVERY_TYPE_ENUM } from '../../../common/constants'
import { useAppSelector } from '../../../common/hooks'

import {
  StyledAlert,
  StyledDeliveryDate,
  StyledDescriptions,
  StyledParagraph,
  StyledPriceContainer,
  StyledTag,
  StyledTitle,
  StyledToggleButton,
  StyledToggleButtonGroup,
  StyledType,
} from './styles/ShippingTypes.style'
import { getDeliveryDate, getShippingInfos } from '../../../common/utils'
import { getMissionsDiscount, getSelectedMissionMinOrderAmount } from '../../../common/missions'

export const ShippingTypesSelector = () => {
  const { cart, scheduledDelivery, missions } = useAppSelector((state) => state)
  const deliveryType = useAppSelector((state) => state.shippingInfos.shippingType)
  const { isScheduleEnabled } = useAppSelector((state) => state.session)

  const fee = getShippingInfos(deliveryType, isScheduleEnabled!, scheduledDelivery).value
  const discountAmount = getMissionsDiscount(missions, cart, fee)
  const selectedMission = getSelectedMissionMinOrderAmount(missions)

  const deliveryDate = getDeliveryDate()

  return (
    <StyledToggleButtonGroup value={deliveryType} exclusive data-testid="toggle-group">
      <StyledToggleButton
        value={DELIVERY_TYPE_ENUM.twoDays}
        disabled={true}
        data-testid="shipping-type"
      >
        <StyledType>
          <StyledTitle>
            <StyledTag>Entrega estimada:</StyledTag>
            <StyledPriceContainer>
              {discountAmount ? (
                <div className="free-shipping">Grátis</div>
              ) : (
                <Money
                  amount={DELIVERY_TYPES.twoDays.value}
                  isBold={deliveryType === DELIVERY_TYPE_ENUM.twoDays}
                />
              )}
            </StyledPriceContainer>
          </StyledTitle>
          <StyledDeliveryDate>{deliveryDate}</StyledDeliveryDate>
          <StyledDescriptions className="days-to-delivery">
            <StyledParagraph>
              Seu pedido possui um prazo de entrega maior que 1 dia, pois possui produtos de
              parceiros.
            </StyledParagraph>
            <StyledAlert>
              Precisa receber antes? Por favor, remova os itens com a etiqueta “Parceiro”.
            </StyledAlert>
            {discountAmount ? (
              <StyledParagraph>Frete grátis, pois completou a missão!</StyledParagraph>
            ) : (
              <StyledParagraph>
                {selectedMission
                  ? `Pedidos acima de R$${selectedMission} ganham frete grátis`
                  : 'Ative uma missão para ganhar frete grátis'}
              </StyledParagraph>
            )}
          </StyledDescriptions>
        </StyledType>
      </StyledToggleButton>
    </StyledToggleButtonGroup>
  )
}
